// extracted by mini-css-extract-plugin
export var cardHeader = "_h5-1";
export var contentCard = "_h5-0";
export var headerActions = "_h5-3";
export var reorderHandle = "_h5-5";
export var titleArea = "_h5-2";
export var titleAreaWithHandle = "_h5-4";